import { styled } from '@mui/material/styles';
import { Box } from '@monorepo/nova-ui';

export const StyledTradesTableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  minHeight: '400px',
  flex: '1 1 100%',
  display: 'flex',
  flexDirection: 'column',
  minWidth: theme.breakpoints.up('md') ? '100%' : '0',
  padding: `${theme.spacing(4)} ${theme.spacing(4)}`,
}));
